import { notification } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideLoading,
  showLoading,
  showAlert,
  getTypes,
  hideAlert,
} from "../../Store/Actions/GeneralActions";
function Alert() {
  const alert = useSelector((state) => state.GeneralReducer.alertOptions);
  const dispatch = useDispatch();

  console.log("alert", alert);
  useEffect(() => {
    notification.open({
      message: alert?.message ? alert?.message : "Network Error",
      duration: 3,
      type: alert?.type?.toLowerCase(),
      placement: "top",
      onClose: () => dispatch(hideAlert()),
    });
  }, []);
  return null;
}

export default Alert;
